<template>
  <v-btn
    icon
    v-if="notificationsCount > 0"
    @click.stop="openDialog"
  >
    <v-badge overlap color="primary">
      <template v-slot:badge>{{ notificationsCount }}</template>
        <v-icon>mdi-bell-ring-outline</v-icon>
    </v-badge>
  </v-btn>

    <!--<v-card scrollable max-width="320px">
        <v-toolbar flat style="z-index:5;">
          <v-toolbar-title class="not-title">{{ $t('Alarmy') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="menuOpened = !menuOpened">
            <v-icon>mdi-close</v-icon>
          </v-btn>
            <v-fab-transition>
              <v-btn
                fab
                color="primary"
                small
                bottom
                left
                absolute
                v-show="menuOpened"
                @click="approveAll"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-fab-transition>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text style="height: 380px; overflow-y: auto;" class="pa-0">
        <v-timeline dense clipped class="bell">
          <v-slide-x-transition group>
            <v-timeline-item
              small
              fill-dot
              v-for="item in notifications"
              :key="item.id"
              :color="colors[item.type]"
            >
              <v-btn slot="icon" icon small @click="approveItem(item.id)">
                <v-icon>{{ icons[item.type] }}</v-icon>
              </v-btn>
              <div class="pr-3">
                <div class="caption">{{ item.displayName }}</div>
                <strong>{{ $t('alarm' + item.message) }}</strong>
                <div class="caption">{{ item.date }}</div>
              </div>
            </v-timeline-item>
          </v-slide-x-transition>
        </v-timeline>
        </v-card-text>
      </v-card>-->
</template>

<script>
export default {
  data: () => ({
    menuOpened: false
  }),
  computed: {
    notifications() {
      //return this.$store.state['notifications'].notifications.reverse() 
      return this.$store.getters['notifications/notApproved'].reverse();
    },
    notificationsCount() {
      return this.$store.getters['notifications/counter'];
    },
    icons() {
      return this.$store.state['notifications'].icons
    },
    colors() {
      return this.$store.state['notifications'].colors
    }
  },
  methods: {
    openDialog() {
      this.$store.state['notifications'].showAlerts = true;
    },
    approveAll() {
      //this.$store.dispatch(`notifications/approveNotifications`, this.notifications);
    },
    approveItem(id) {
      console.log(id);
      
      this.$store.dispatch(`notifications/approveNotifications`, [{id: id}]);
    }
  }
}
</script>
<style>
/*.slide-enter {
  opacity: 0;
}
.slide-enter-active {
  animation: slide-in 1s ease-out forwards;
  transition: opacity .5s;
}
.slide-leave {

}
.slide-leave-active {
  animation: slide-out 1s ease-out forwards;
  transition: opacity 1s;
  opacity: 0;
}
.slide-move {
  transition: transform 1s;
}

@keyframes slide-in {
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(20px);
  }
}*/
</style>